import { GoogleLoginProvider, SocialAuthServiceConfig } from "@abacritt/angularx-social-login";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { ConfigService } from "./config/config.service";

@Injectable({
  providedIn: "root",
})

/**
 * Servicio que se encarga de inicializar el Social Login con las credenciales de Google si están disponibles.
 */
export class DynamicSocialLoginService {
  constructor(private configService: ConfigService) {}

  async initializeSocialLogin(): Promise<SocialAuthServiceConfig> {
    try {
      const config = await firstValueFrom(this.configService.getConfigPrensa());
      if (!config) return;
      const providers = [];
      const googleClientId = config["general"]["global-constants"]["social-login-google-client-id"];
      if (googleClientId) {
        providers.push({
          id: GoogleLoginProvider.PROVIDER_ID,
          provider: new GoogleLoginProvider(googleClientId),
        });
      }

      const socialAuthServiceConfig: SocialAuthServiceConfig = {
        autoLogin: false,
        providers: providers,
        onError: (err) => console.error(err),
      };

      return socialAuthServiceConfig;
    } catch (error) {
      throw error;
    }
  }
}
